<template lang="html">
  <table class="table mb-0 table-striped">
    <thead class="bg-light">
      <tr>
        <th scope="col" class="border-0">#</th>
        <th scope="col" class="border-0">Nome</th>
        <th scope="col" class="border-0">Opções</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(row, index) in words" :key="index">
        <td>{{ row.id }}</td>
        <td class="td-4 link">
          <d-link :to="{ name: 'admin-word-edit', params: { wordId: row.id }}">{{ row.word }}</d-link>
        </td>
        <td class="td-2">
          <word-buttons :word="row"></word-buttons>
        </td>
      </tr>
      <tr v-if="words.length === 0">
        <td colspan="7" class="no-content">Ainda não tem nenhum jogo cadastrado.</td>
      </tr>
    </tbody>
    <confirmation-modal
      :cancel="close"
      :confirm="deleteRow"
      title="Confirme exclusão da palavra"
      message="Tem certeza que deseja excluir esta palavra?"/>
  </table>
</template>

<script>
import Events from '_utils/events';
import ConfirmationModal from '_shared/ConfirmationModal.vue';
import WordButtons from './WordButtons.vue';
import WordDelete from './WordDelete';
import { _DELETE_WORD_ } from './WordModel';

export default {
  name: 'word-table',
  mixins: [WordDelete],
  components: {
    WordButtons,
    ConfirmationModal,
  },
  props: {
    words: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      selectWord: null,
    };
  },
  mounted() {
    Events.$on(_DELETE_WORD_, word => {
      this.selectWord = word.id;
    });
  },
};
</script>

<style lang="scss" scoped>
@import '~_scss/overrides';

.link {
  color: $primary;
  a {
    cursor: pointer;
  }
}

.td {
  &-2 {
    min-width: 140px;
  }
  &-3 {
    min-width: 140px;
  }
  &-4 {
    min-width: 200px;
  }
}
</style>
